/* CALE — restrained reveal-on-scroll. Progressive enhancement: without JS, everything
   shows normally (the hidden state only applies under html.cale-js, set inline in <head>). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SELECTORS = [
    '.cale-hero__copy', '.cale-hero__visual',
    '.cale-industries__bar',
    '.cale-packages__head', '.cale-pkg', '.cale-extras',
    '.cale-work__item',
    '.cale-partners__head',
    '.cale-why__top', '.cale-why__point',
    '.cale-process__intro', '.cale-process__step',
    '.cale-faq__aside', '.cale-faq__item',
    '.cale-contact__intro', '.cale-contact__formwrap'
  ].join(',');

  function init() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(SELECTORS));
    if (!nodes.length) return;

    // Tag for the initial (hidden) state and give grouped items a gentle stagger.
    nodes.forEach(function (el) {
      el.classList.add('cale-anim');
      var siblings = el.parentElement ? el.parentElement.children : [];
      var i = Array.prototype.indexOf.call(siblings, el);
      var delay = Math.min(i < 0 ? 0 : i, 5) * 60;
      el.style.transitionDelay = delay + 'ms';
    });

    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('cale-anim--in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cale-anim--in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function (el) { io.observe(el); });
  }

  function initCarousels() {
    document.querySelectorAll('[data-cale-carousel]').forEach(function (track) {
      var scope = track.closest('section') || document;
      var prev = scope.querySelector('[data-cale-carousel-prev]');
      var next = scope.querySelector('[data-cale-carousel-next]');
      var cur = scope.querySelector('[data-cale-carousel-current]');
      function step() {
        var first = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
        return first ? first.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function go(dir) { track.scrollBy({ left: dir * step(), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      if (cur) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / step()) + 1;
          cur.textContent = Math.max(1, Math.min(track.children.length, i));
        }, { passive: true });
      }
    });
  }

  function maybeOpenFromHash() {
    var h = (location.hash || '').toLowerCase();
    if (h === '#industries' || h === '#cale-industries') {
      var d = document.querySelector('.cale-ind-modal');
      if (d && typeof d.showModal === 'function' && !d.open) { try { d.showModal(); } catch (e) {} }
    }
  }

  function boot() { init(); initCarousels(); maybeOpenFromHash(); }
  window.addEventListener('hashchange', maybeOpenFromHash);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Lightweight <dialog> wiring: [data-cale-dialog-open="id"] opens, [data-cale-dialog-close]
     and a backdrop click close. ESC + focus trap come free from native <dialog>. */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cale-dialog-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-cale-dialog-open'));
      if (dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); }
      return;
    }
    var closer = e.target.closest('[data-cale-dialog-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
      return;
    }
    // Click on the backdrop (the dialog element itself, outside the panel) closes it.
    if (e.target.tagName === 'DIALOG' && e.target.open) {
      var panel = e.target.querySelector(':scope > *');
      if (panel) {
        var r = panel.getBoundingClientRect();
        var outside = e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
        if (outside) e.target.close();
      }
    }
  });
})();
